// 引入各个语言配置文件
import zh from './zh'
import en from './en'
// 创建文件vueIN.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang

Vue.use(VueI18n)
// 创建vue-i18n实例i18n
const i18n = new VueI18n({
  // 设置默认语言
  locale: localStorage.getItem('languageSet') || 'en', // 语言标识
  // 添加多语言（每一个语言标示对应一个语言文件）
  messages: {
    en: {
      ...en,
      ...elementEnLocale
    },
    zh: {
      ...zh,
      ...elementZhLocale
    }
  }
})
ElementLocale.i18n((key, value) => i18n.t(key, value))
// 暴露i18n
export default i18n



// WEBPACK FOOTER //
// ./src/util/vueIN.js